export enum DataTableType {
  facility = 0,
  company = 1,
  vnb = 2,
}
